import { getDealerOrdersInvoicesDt } from "~/helpers/backendHelper";
import { getDealerOrdersInvoicesDtErr, getDealerOrdersInvoicesDtOk } from "./actions";
import { GET_DEALER_ORDERS_INVOICES_DT } from "./actionTypes";
import { takeEvery, put, call } from "redux-saga/effects";

/********** DATATABLE **********/

function* onGetDealerOrdersInvoicesDt({ payload: { params } }) {
  try {
    const response = yield call(getDealerOrdersInvoicesDt, params);
    yield put(getDealerOrdersInvoicesDtOk(response));
  } catch (error) {
    yield put(getDealerOrdersInvoicesDtErr(error));
  }
}

function* dealerOrdersInvoicesSaga() {
  yield takeEvery(GET_DEALER_ORDERS_INVOICES_DT, onGetDealerOrdersInvoicesDt);
}

export default dealerOrdersInvoicesSaga;